export default __webpack_public_path__ + "static/time-axis-with-irregular-intervals-408b748f581b7ac61df020064bca4e97.png";